"use client";
import { jsxs as r, Fragment as e, jsx as C } from "react/jsx-runtime";
import { createSvgIcon as t } from "@mui/material/utils";
const l = t(
  /* @__PURE__ */ r(e, { children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M15.88 8.39999C15.55 8.18999 15.11 8.27999 14.9 8.60999L10.92 14.8L9.04001 12.54C8.79001 12.24 8.34001 12.2 8.04001 12.45C7.74001 12.7 7.70001 13.15 7.95001 13.45L10.45 16.45C10.59 16.61 10.79 16.71 11 16.71C11.01 16.71 11.03 16.71 11.04 16.71C11.27 16.7 11.47 16.58 11.59 16.39L16.09 9.38999C16.3 9.05999 16.21 8.61999 15.88 8.40999V8.39999Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M12 2.29001C6.65004 2.29001 2.29004 6.65001 2.29004 12C2.29004 17.35 6.65004 21.71 12 21.71C17.35 21.71 21.71 17.35 21.71 12C21.71 6.65001 17.35 2.29001 12 2.29001ZM12 20.29C7.43004 20.29 3.71004 16.57 3.71004 12C3.71004 7.43001 7.43004 3.71001 12 3.71001C16.57 3.71001 20.29 7.43001 20.29 12C20.29 16.57 16.57 20.29 12 20.29Z",
        fill: "currentColor"
      }
    )
  ] }),
  "KmxCheckCircleStroked"
);
export {
  l as default
};
